import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MessagesComponent } from './messages/messages.component';
import { IonicModule } from '@ionic/angular';
import { ComponentsAdminModule } from '../../../componentsAdmin/components-admin.module';
import { PreviewChatComponent } from './preview-chat/preview-chat.component';

const declarations = [MessagesComponent, PreviewChatComponent];

@NgModule({
  declarations,
  imports: [IonicModule, CommonModule, ComponentsAdminModule],
  exports: declarations,
})
export class SuggestionsChatComponentsModule {}
